import React from "react";

import { List, Datagrid, TextField, ShowButton, EditButton, DeleteWithConfirmButton } from "react-admin";
import { EmptyList } from "../../../../common/components";

const ListPublicProcurementActProcedures = () => {
  return (
    <List
      hasCreate
      exporter={false}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />

        <TextField
          label="Име на процедура"
          source="name"
          sortable={false}
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListPublicProcurementActProcedures;
